import { infiniteQueryOptions } from '@tanstack/react-query';
import { getFeed } from '@/lib/api';
import { keys } from '@/lib/query-client';

/**
 * One definition for the home feed's first read, pagination, and freshness.
 *
 * It is consumed twice on purpose: once before React renders, so `/me` and the
 * first feed page cross the network together, and once by `FeedScreen`, which
 * adopts that in-flight request or its cached result. Keeping the options here
 * prevents boot preloading and the mounted infinite query from drifting into two
 * cache entries or disagreeing about cursors.
 */
export const feedQueryOptions = () =>
  infiniteQueryOptions({
    queryKey: keys.feed,
    queryFn: ({ pageParam, signal }) => getFeed(pageParam || undefined, signal),
    initialPageParam: '',
    getNextPageParam: (last) => last.cursor,
    /* Returning home paints the cached column immediately, then reconciles after
       this quiet window. */
    staleTime: 60_000,
  });
